export interface Module {
  num: string
  title: string
  lines: string[]
}

export const modules: Module[] = [
  {
    num: '01',
    title: '✅ VALUTAZIONE CLINICA & PIANIFICAZIONE TERAPEUTICA™',
    lines: [
      "Strumenti organizzati per raccogliere informazioni, strutturare l'osservazione, identificare priorità, definire obiettivi e costruire un piano di intervento coerente.",
      'Include checklist, matrici, modelli e strumenti professionali pronti da utilizzare e adattare.',
    ],
  },
  {
    num: '02',
    title: '✅ LIBRERIA PROFESSIONALE DI ATTIVITÀ LOGOPEDICHE™',
    lines: [
      'Attività organizzate per articolazione, fonologia, linguaggio ricettivo ed espressivo, vocabolario, morfosintassi, narrazione, consapevolezza fonologica, fluenza e comunicazione funzionale.',
      'Ogni attività include obiettivo, applicazione, livello di difficoltà, progressione e possibilità di adattamento.',
    ],
  },
  {
    num: '03',
    title: "✅ SESSIONI LOGOPEDICHE PRONTE ALL'USO™",
    lines: [
      'Sessioni già strutturate con obiettivo, preparazione, attività iniziale, lavoro principale, esercizi complementari, adattamenti e chiusura.',
      'Scegli la sessione più adatta, personalizzala secondo le necessità del paziente e utilizzala nella pratica.',
    ],
  },
  {
    num: '04',
    title: '✅ OBIETTIVI, PROGRESSIONI & PERCORSI TERAPEUTICI™',
    lines: [
      'Percorsi organizzati per trasformare un obiettivo in una sequenza di lavoro coerente.',
      'Include progressioni, livelli di difficoltà, criteri per avanzare o modificare il lavoro e strutture per organizzare più sessioni mantenendo continuità terapeutica.',
    ],
  },
  {
    num: '05',
    title: '✅ MONITORAGGIO, DOCUMENTAZIONE & PROGRESSI™',
    lines: [
      'Strumenti per registrare le sessioni, monitorare le risposte, verificare gli obiettivi e organizzare le informazioni necessarie per pianificare il lavoro successivo.',
      "Schede di monitoraggio, note strutturate, registri e modelli di revisione pronti all'uso.",
    ],
  },
  {
    num: '06',
    title: '✅ MATERIALI TERAPEUTICI & TOOLKIT PROFESSIONALE™',
    lines: [
      'Schede, carte, stimoli verbali, esercizi, attività stampabili, tabelle, materiali per la pratica a casa e strumenti di supporto organizzati per obiettivo.',
      'Materiale concreto da selezionare e utilizzare direttamente durante il lavoro professionale.',
    ],
  },
]

export interface Bonus {
  label: string
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    label: '🎁 BONUS 1',
    title: 'BANCA PROFESSIONALE DI OBIETTIVI TERAPEUTICI™',
    description:
      'Una risorsa strutturata con obiettivi osservabili e misurabili organizzati per diverse aree di intervento, con criteri di raggiungimento, livelli di difficoltà, indicatori di progressione e modelli per costruire obiettivi individualizzati.',
  },
  {
    label: '🎁 BONUS 2',
    title: 'KIT DI COMPITI TERAPEUTICI PER CASA™',
    description:
      'Attività strutturate da utilizzare per dare continuità al lavoro fuori dalla sessione, con obiettivi, istruzioni, durata, frequenza, livello di difficoltà, adattamenti e semplici strumenti di monitoraggio.',
  },
  {
    label: '🎁 BONUS 3',
    title: 'PROTOCOLLO DI REVISIONE DEL CASO™',
    description:
      "Un sistema professionale per analizzare periodicamente l'evoluzione del lavoro, confrontare i risultati, verificare gli obiettivi e decidere quando mantenere, progredire, modificare o concludere un obiettivo terapeutico.",
  },
  {
    label: '🎁 BONUS 4',
    title: 'TOOLKIT DI ADATTAMENTO DELLE ATTIVITÀ™',
    description:
      "Strumenti pratici per aumentare o ridurre la difficoltà delle attività in base alla risposta osservata, modificando supporto, stimoli, complessità, modalità di risposta e livello di generalizzazione senza perdere di vista l'obiettivo.",
  },
  {
    label: '🎁 BONUS 5',
    title: 'SCHEDE DI SINTESI & COMUNICAZIONE PROFESSIONALE™',
    description:
      'Modelli pronti per sintetizzare obiettivi, attività svolte, progressi, difficoltà e prossimi passi e per organizzare una comunicazione chiara con famiglie, caregiver e altri professionisti quando necessario.',
  },
]

export interface Benefit {
  title: string
  lines: string[]
}

export const benefits: Benefit[] = [
  {
    title: '⚡ Risparmia Ore Ogni Settimana',
    lines: [
      'Smetti di partire da una pagina bianca ogni volta che devi preparare il lavoro.',
      'Apri il sistema.',
      "Individua l'obiettivo.",
      'Scegli attività e materiali.',
      'Adatta ciò che serve.',
      'E prepara il tuo lavoro in molto meno tempo.',
    ],
  },
  {
    title: '👑 Organizza Meglio la Tua Pratica Professionale',
    lines: [
      'Valutazione.',
      'Obiettivi.',
      'Sessioni.',
      'Attività.',
      'Progressioni.',
      'Monitoraggio.',
      'Materiali.',
      'Finalmente puoi lavorare con un sistema che mantiene questi elementi organizzati e collegati tra loro.',
    ],
  },
  {
    title: "🤝 Mantieni Continuità tra una Sessione e l'Altra",
    lines: [
      "Non limitarti a scegliere un'attività per la giornata.",
      'Lavora attraverso obiettivi, progressioni e percorsi strutturati che ti aiutano a mantenere una direzione chiara nel tempo.',
    ],
  },
  {
    title: '😊 Concentrati Finalmente sul Paziente',
    lines: [
      'Dedica meno tempo a cercare schede, costruire attività, organizzare documenti e preparare ogni sessione da zero.',
      'Dedica più tempo a osservare, adattare, guidare e lavorare con il paziente.',
      'È qui che la tua esperienza professionale fa davvero la differenza.',
    ],
  },
]
